module.exports = __webpack_public_path__ + "static/media/sell_request_details_make_1.2a5c771d.png";